import React from 'react';

import { WarningDialog } from '../../../components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import ServiceRunVehicleDetail from '../../servicerun/ServiceRunDetail/ServiceRunVehicleDetail';

/**
 * StopVehicleDialog: the vehicle assignment prompt after the restock, as on
 * the classic stop screen.
 * Props: serviceRun, isOpen, setIsOpen, canClose, onUpdated, isTraining, isOnline
 */
const StopVehicleDialog = ({ serviceRun, isOpen, setIsOpen, canClose, onUpdated, isTraining, isOnline }) => {
	const vehicleStyles = useThemedStyles(createVehicleStyles);
	const hasAssignedVehicle = Boolean(serviceRun?.vehicle?.id);

	return (
		<WarningDialog
			title="Vehicle assignment"
			texts={[hasAssignedVehicle
				? 'Confirm the vehicle for the current service run to continue'
				: 'Assign a vehicle to the current service run to continue']}
			subtext={hasAssignedVehicle
				? 'Please confirm the assigned vehicle is the one you are driving today, or select a different vehicle.'
				: 'Please assign a vehicle using the button below to be able to close this dialog and continue.'}
			setIsOpen={setIsOpen}
			isOpen={isOpen}
			hideButtons={true}
			enableCloseDialog={canClose}
		>
			<ServiceRunVehicleDetail
				servicerun={serviceRun}
				styles={vehicleStyles}
				setShowDialogOpen={setIsOpen}
				showConfirmButton={true}
				onUpdated={onUpdated}
				adminTraining={isTraining}
				disableActions={isTraining && !isOnline}
			/>
		</WarningDialog>
	);
};

// Styles ServiceRunVehicleDetail expects (same keys as on the classic stop screen).
const createVehicleStyles = ({ ui: { colors, type, space } }) => ({
	firstButton: {
		flex: 1,
	},
	secondButton: {
		marginLeft: space.md,
		flex: 1,
	},
	headerText: {
		...type.cardTitle,
		color: colors.text,
	},
});

export default StopVehicleDialog;
